import axios from "axios";
const debug = process.env.NODE_ENV !== "production";
import { VUE_APP_API_URL } from "@utils/index";

const instance = axios.create({
  baseURL: VUE_APP_API_URL + "/api",
  timeout: 30000,
  headers: {
    "X-CSRF-TOKEN": "xxx"
  }
});

function baseRequest(options) {
  if (debug) console.log(options);
  return instance(options)
    .then(res => {
      const data = res.data || {};
      if (res.status !== 200)
        return Promise.reject({ msg: "网络异常", res, data });
      if (data.status === 1) {
        return Promise.resolve(data.data, res);
      } else {
        return Promise.reject({ msg: data.msg || "系统繁忙", res, data });
      }
    })
    .catch(res => {
      return Promise.reject({ msg: res.msg || "系统繁忙" });
    });
}

/**
 * http 请求基础类
 * 参考文档 https://www.kancloud.cn/yunye/axios/234845
 *
 */
const request = ["post", "put", "patch"].reduce((request, method) => {
  /**
   *
   * @param url string 接口地址
   * @param params object get参数
   * @param options object axios 配置项
   * @returns {AxiosPromise}
   */
  request[method] = (url, data = {}, options = {}) => {
    return baseRequest(Object.assign({ url, data, method }, options));
  };
  return request;
}, {});

["get", "delete", "head"].forEach(method => {
  /**
   *
   * @param url string 接口地址
   * @param params object get参数
   * @param options object axios 配置项
   * @returns {AxiosPromise}
   */
  request[method] = (url, params = {}, options = {}) => {
    return baseRequest(Object.assign({ url, params, method }, options));
  };
});

export default request;
